// extracted by mini-css-extract-plugin
export default {"navItemContainer":"NavItem_navItemContainer__RLvn2","navItem":"NavItem_navItem__gokot","activeLink":"NavItem_activeLink__WE8bV"};